/* Carosello delle recensioni della home (sections/cube-home-reviews).

   Sta qui e non dentro la sezione perche' il file della sezione era
   diventato troppo grosso per essere caricato in un colpo solo.

   Lo scorrimento automatico si ferma da solo quando il puntatore e'
   sopra il carosello, quando qualcuno usa frecce o puntini, e quando
   la sezione non e' in vista. Chi ha chiesto al sistema di ridurre le
   animazioni non vede muoversi niente da solo. */
(function () {
  var RIPOSO = 5200;

  function initRec(scena) {
    if (!scena || scena.dataset.cubeRec === '1') return;
    var pista = scena.querySelector('[data-rec-pista]');
    if (!pista) return;
    scena.dataset.cubeRec = '1';

    var indietro = scena.querySelector('.cube-rec__freccia--indietro');
    var avanti = scena.querySelector('.cube-rec__freccia--avanti');
    var punti = scena.querySelector('[data-rec-punti]');
    var calmo = window.matchMedia('(prefers-reduced-motion: reduce)');

    var timer = null;
    var sospeso = false;  /* puntatore sopra, o messa a fuoco da tastiera */
    var invista = true;
    var mano = false;     /* qualcuno ha preso il comando: non riparte piu' */

    /* 2px di tolleranza: le larghezze frazionarie non arrivano mai
       esattamente a zero ne' esattamente al massimo */
    function limite() { return pista.scrollWidth - pista.clientWidth; }
    function scorre() { return limite() > 2; }
    function pagine() { return Math.max(1, Math.round(limite() / pista.clientWidth) + 1); }
    function pagina() { return Math.round(pista.scrollLeft / pista.clientWidth); }

    function vai(dove) { pista.scrollTo({ left: dove, behavior: 'smooth' }); }

    function passo(verso) {
      var una = pista.querySelector('.cube-rec__it, .cube-rec__tutte');
      var largo = una ? una.getBoundingClientRect().width + 16 : pista.clientWidth;
      vai(pista.scrollLeft + verso * largo);
    }

    function avanza() {
      if (pista.scrollLeft >= limite() - 2) vai(0);
      else passo(1);
    }

    function ferma() { if (timer) { clearInterval(timer); timer = null; } }

    function riparti() {
      ferma();
      if (calmo.matches || mano || sospeso || !invista || !scorre()) return;
      timer = setInterval(avanza, RIPOSO);
    }

    function disegnaPunti() {
      if (!punti) return;
      var quante = pagine();
      if (punti.children.length !== quante) {
        punti.innerHTML = '';
        for (var i = 0; i < quante; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'cube-rec__punto';
          b.setAttribute('aria-label', 'Vai al gruppo ' + (i + 1));
          b.dataset.i = i;
          punti.appendChild(b);
        }
      }
      var attiva = pagina();
      for (var j = 0; j < punti.children.length; j++) {
        punti.children[j].setAttribute('aria-current', j === attiva ? 'true' : 'false');
      }
    }

    function aggiorna() {
      var puo = scorre();
      if (indietro) indietro.hidden = !puo;
      if (avanti) avanti.hidden = !puo;
      if (punti) punti.hidden = !puo;
      disegnaPunti();
      riparti();
    }

    if (indietro) indietro.addEventListener('click', function () { mano = true; ferma(); passo(-1); });
    if (avanti) avanti.addEventListener('click', function () { mano = true; ferma(); avanza(); });
    if (punti) punti.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.cube-rec__punto') : null;
      if (!b) return;
      mano = true;
      ferma();
      vai(parseInt(b.dataset.i, 10) * pista.clientWidth);
    });

    scena.addEventListener('mouseenter', function () { sospeso = true; ferma(); });
    scena.addEventListener('mouseleave', function () { sospeso = false; riparti(); });
    scena.addEventListener('focusin', function () { sospeso = true; ferma(); });
    scena.addEventListener('focusout', function () { sospeso = false; riparti(); });
    pista.addEventListener('touchstart', function () { mano = true; ferma(); }, { passive: true });

    pista.addEventListener('scroll', function () { requestAnimationFrame(disegnaPunti); }, { passive: true });
    window.addEventListener('resize', aggiorna);

    if (window.IntersectionObserver) {
      new IntersectionObserver(function (voci) {
        invista = voci[0].isIntersecting;
        riparti();
      }, { threshold: 0.2 }).observe(scena);
    }

    requestAnimationFrame(aggiorna);
  }

  document.querySelectorAll('.cube-rec__scena').forEach(initRec);
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector ? e.target.querySelector('.cube-rec__scena') : null;
    if (s) initRec(s);
  });
})();
